import BossModel from "@/models/BossModel";
import Version from "@/models/Customer/Traveller/Version/Version";

export default class Traveller extends BossModel {

    static apiUrl = 'customer/traveller';

    static entity = 'customerTravellers';

    static fields(){
        return {
            id: this.number(null).nullable(),
            customer_id: this.number(null),
            is_active: this.boolean(null),
            latestVersion: this.hasOne(Version, 'customer_traveller_id'),
            versions: this.hasMany(Version, 'customer_traveller_id'),
        }
    }
}
